module.exports = __webpack_public_path__ + "fonts/Lufthansa Head Light.2786f7fd.otf";